import { Types } from "@/@Interfaces/Categories";

export const types: Types[] = [
  { value: "Ticketed", label: "Ticketed" },
  { value: "Guest List", label: "Guest List" },
  { value: "Exhibition", label: "Exhibition" },
];
